// Imports
import { atom } from 'recoil'


export const walletAddress = atom({
  key: 'walletAddress',
  default: ''
})